import '@abraham/reflection';

import type { AssetFilesLoader } from '@boost/widget-integration-tae/lib';
import { getBoostTAE } from '@boost/widget-integration-tae/lib';
import { bootstrap, setupGlobalExtensions } from 'framework/core';

import { AppModule } from './modules/app/app.module';
import { warmupWorkers } from './workers/workers-provider';

async function main() {
  warmupWorkers();
  setupGlobalExtensions();

  const TAEApp = getBoostTAE();

  TAEApp.onReady(async () => {
    // Wait for customized script to be loaded
    try {
      await (TAEApp.getModuleByName('AssetFilesLoader') as AssetFilesLoader).assetLoadingPromise(
        'customizedScript'
      );
    } catch (error) {
      TAEApp.logger.error('Failed to load customized script', error);
    }

    await window.boostWidgetIntegration.onBeforeAppBootstrap?.();
    await bootstrap(AppModule);
  });
}

main();
